// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Xaa-z","narrowOptionButtons":"Yaa-z","noOptions":"Zaa-z"};